"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
function ToolsSettingsPopup({ title, children }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { role: "dialog", "data-e2e": 'ToolsSettingsPopup_Container', children: [(0, jsx_runtime_1.jsx)(Header, { "data-e2e": 'ToolsSettingsPopup_Header', children: title }), children] }));
}
exports.default = ToolsSettingsPopup;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  width: 200px;

  background: ${props => props.theme.backgroundQuaternary};

  border-radius: 8px;
`;
const Header = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;

  height: 60px;

  color: ${props => props.theme.text};

  font-size: 20px;

  background: ${props => props.theme.dropdown.line};

  border-bottom: 1px solid ${props => props.theme.tools.spurs.headerBorder};
  border-radius: 8px 8px 0 0;
`;
